.ux-form {
  display: block;
}
